export default "__VITE_ASSET__B2mJ1$EG__"